import React from "react";
import styled from "styled-components";

const ListaArticulos = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: ${(props) => props.theme.coleccionListaArticulosMargin};
`;
const ArticuloFoto = styled.li`
  width: 21% !important;
  margin: 2%;
  padding: 0;
  img {
    width: 100%;
    mix-blend-mode: multiply;
  }
`;
const ColeccionArticulos = ({ articulos }) => {
  return (
    <ListaArticulos>
      {articulos.map((articulo) => (
        <ArticuloFoto key={articulo.id}>
          <a href={articulo.urlseo}>
            <img
              src={articulo.foto}
              alt={articulo.titulo}
              title={articulo.titulo}
            />
          </a>
        </ArticuloFoto>
      ))}
    </ListaArticulos>
  );
};

export default ColeccionArticulos;
